export class SimpleSearch {
    data;
    stringify;
    constructor(data, stringify){
        this.data = data;
        this.stringify = stringify // A function to convert each item to a string for comparison
        ;
    }
    // Simple fuzzy search method
    search(query) {
        // function to remove all non-alphanumeric characters, including spaces and periods
        function removeNonAlphanumeric(str) {
            return str.replace(/[^a-zA-Z0-9]/g, "");
        }
        const queryNonAlphanumeric = removeNonAlphanumeric(query.toLowerCase());
        return this.data.filter((item)=>{
            const itemString = removeNonAlphanumeric(this.stringify(item).toLowerCase());
            const match = itemString.includes(queryNonAlphanumeric);
            return match ? 1 : 0;
        });
    }
}
